import { OptimizedImage } from "../OptimizedImage";

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  variant?: "default" | "white" | "dark";
}

export function Logo({
  className = "",
  width = 150,
  height = 50,
  variant = "default",
}: LogoProps) {
  // URL real del logo en Cloudinary
  const logoUrl =
    "https://res.cloudinary.com/dq8ig7aly/image/upload/v1749424200/uploads/mfqaixd4bxv74vbcmyuh.png";

  // Diferentes variantes del logo según el contexto
  const getLogoUrl = (): string => {
    switch (variant) {
      case "white":
        // Para variante blanca, podríamos usar un filtro de Cloudinary
        return logoUrl.replace(
          "/uploads/",
          "/uploads/e_contrast:100,e_brightness:100/"
        );
      case "dark":
        // Para variante oscura, podríamos usar un filtro de Cloudinary
        return logoUrl.replace(
          "/uploads/",
          "/uploads/e_contrast:50,e_brightness:50/"
        );
      default:
        return logoUrl;
    }
  };

  return (
    <div
      className={`flex items-center ${className}`}
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <OptimizedImage
        src={getLogoUrl()}
        alt="Cerámicas Gassull"
        width={width}
        height={height}
        quality={90}
        format="webp"
        loading="eager"
        className="w-full h-full"
        onError={() => {
          // Error manejado silenciosamente
        }}
      />
    </div>
  );
}
